import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import {
  Cog6ToothIcon,
  LifebuoyIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "../context/AuthContext";
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import Configuracion from "./OptionsProfile/Configuration";
import Ayuda from "./OptionsProfile/Help";
import Soporte from "./OptionsProfile/Supports";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

export default function ProfileModalProm({ isOpen, onClose }) {
  const { currentUser } = useAuth();
  const [userData, setUserData] = useState({});
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!currentUser) return;

      const userRef = doc(db, "users", currentUser.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        const newUserData = {
          nombre:  currentUser.displayName || "",
          correo:  currentUser.email || "",
          role:    "Estudiante",
          status:  "pending",
        };
        await setDoc(userRef, newUserData);
        setUserData(newUserData);
      } else {
        setUserData(userSnap.data());
      }
    };

    if (isOpen) {
      fetchUserData();
    }
  }, [isOpen, currentUser]);

  const toggleSection = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
  };

  const handleLogout = async () => {
    await signOut(auth);
    onClose();
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="scale-95 opacity-0"
              enterTo="scale-100 opacity-100"
              leave="ease-in duration-200"
              leaveFrom="scale-100 opacity-100"
              leaveTo="scale-95 opacity-0"
            >
              <Dialog.Panel className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
                {/* Datos personales */}
                <div className="mt-6 space-y-2 text-center">
                  <p className="text-lg font-semibold text-gray-900">
                    {userData.nombre || "Nombre no disponible"}
                  </p>
                  <p className="text-sm text-gray-600">
                    {userData.correo || currentUser?.email || "Correo no disponible"}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    Rol: <strong>{userData.role || "—"}</strong>
                  </p>
                  <p className="inline-block mt-1 px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                    {userData.carrera || "Carrera no especificada"}
                  </p>
                </div>

                {/* Opciones */}
                {/* Configuración */}
                <div>
                  <button
                    onClick={() => toggleSection("config")}
                    className="flex items-center justify-between w-full px-4 py-2 rounded hover:bg-gray-100"
                  >
                    <div className="flex items-center">
                      <Cog6ToothIcon className="h-5 w-5 mr-2" />
                      Configuración
                    </div>
                    {activeSection === "config" ? (
                      <ChevronUpIcon className="h-4 w-4" />
                    ) : (
                      <ChevronDownIcon className="h-4 w-4" />
                    )}
                  </button>
                  {activeSection === "config" && <Configuracion />}
                </div>

                {/* Ayuda */}
                <div>
                  <button
                    onClick={() => toggleSection("ayuda")}
                    className="flex items-center justify-between w-full px-4 py-2 rounded hover:bg-gray-100"
                  >
                    <div className="flex items-center">
                      <QuestionMarkCircleIcon className="h-5 w-5 mr-2" />
                      Ayuda
                    </div>
                    {activeSection === "ayuda" ? (
                      <ChevronUpIcon className="h-4 w-4" />
                    ) : (
                      <ChevronDownIcon className="h-4 w-4" />
                    )}
                  </button>
                  {activeSection === "ayuda" && <Ayuda />}
                </div>

                {/* Soporte */}
                <div>
                  <button
                    onClick={() => toggleSection("soporte")}
                    className="flex items-center justify-between w-full px-4 py-2 rounded hover:bg-gray-100"
                  >
                    <div className="flex items-center">
                      <LifebuoyIcon className="h-5 w-5 mr-2" />
                      Soporte
                    </div>
                    {activeSection === "soporte" ? (
                      <ChevronUpIcon className="h-4 w-4" />
                    ) : (
                      <ChevronDownIcon className="h-4 w-4" />
                    )}
                  </button>
                  {activeSection === "soporte" && (
                    <Soporte
                      user={{
                        nombre:
                          userData.nombre || currentUser?.displayName || "Desconocido",
                        uid: currentUser?.uid || "Sin UID",
                      }}
                    />
                  )}
                </div>

                {/* Cerrar sesión */}
                <div className="mt-6">
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-red-600 rounded hover:bg-red-50"
                  >
                    Cerrar sesión
                  </button>
                </div>

                {/* Cerrar modal */}
                <div className="mt-4 text-right">
                  <button
                    className="text-sm text-gray-500 hover:text-gray-800"
                    onClick={onClose}
                  >
                    Cerrar
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}